import { useState, useEffect } from 'react';
import { 
    Tag, 
    Modal, 
    Form, 
    Select, 
    Input, 
    DatePicker, 
    message,
    Typography,
    Menu,
    Tabs,
} from 'antd';
import { KeyTransactionHistory } from './keyTransactions';
import { KeyOverview } from './keOverview';
import { KeyAuditTimeline } from './keyAuditTimeline';
import { SiteBilling } from '../site/siteDetailPage/component/siteBilling/siteBilling';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { useQuery } from '@apollo/client';
import { getKeyByIdQuery } from '../../util/query/keyRegister.query';
import { KeyAuditConductModal } from './keyAuditConduct.modal';

const { Title, Text } = Typography;
const { TextArea } = Input;
const { TabPane } = Tabs;

const KeyDetailPage = ({ keyId, visible, close }) => {

    const [activeTab, setActiveTab] = useState("overview");

    const {data, loading} = useQuery(getKeyByIdQuery,{
        variables:{
            keyId: keyId
        },
        skip: !keyId,
        fetchPolicy:'network-only'
    })

    const [keyData, setKeyData] = useState(null)
    
    useEffect(()=>{
        setKeyData(data?.getKeyById?.response);
        console.log(data?.getKeyById?.response, "data?.getKeyById?.response")
    },[data?.getKeyById?.response]);




    return (
        <Modal
            open={visible}
            width={'70%'}
            style={{top:0}}
            closable={false}
            footer={null}
            loading={loading}
        >
            <div >
                {/* Header */}
                <div className='modal-header-title'>
                    <span style={{letterSpacing:'0.2px'}}> {keyData?.site?.sitename} </span>
                    <span  onClick={close}><FontAwesomeIcon className='close' icon={faClose}/></span>
                </div>


                
                <div className='modal-body-padding' style={{overflowY: 'auto', maxHeight:'85vh'}}>

                    {/* Tabs Navigation */}
                    <div className="setting-body editDutyModal-sm" style={{ margin:'10px', padding:0, flex:'auto', width: '100%', maxWidth:'100%', zIndex:2} }>
                        <div className="setting-body-inner" style={{margin:0, padding:0}}>
                
                            <Tabs
                                activeKey={activeTab}
                                onChange={setActiveTab}
                                className="edit-tabs"
                            >
                                <TabPane tab="Overview" key="overview" />
                                <TabPane tab="Audit" key="audit" />
                                <TabPane tab="History" key="history" />
                                {/* <TabPane tab="Billing Setup" key="billing" /> */}
                            </Tabs>

                            {activeTab === "overview" && <KeyOverview keyData={keyData} />}
                            {activeTab === "audit" && (
                                <KeyAuditTimeline
                                    keyId={keyData?._id}
                                    keyData={keyData}
                                />
                            )}
                            {activeTab === "history" && (
                                <KeyTransactionHistory keyId={keyData?._id} />
                            )}
                            {activeTab === "billing" && (
                                <SiteBilling siteId={keyData?.siteId} />
                            )}
                        
                        </div>
                    </div>


                </div>



                
            </div>
        </Modal>
    );
};

export default KeyDetailPage;